import { render, staticRenderFns } from "./getidentity.vue?vue&type=template&id=4ba4e813&scoped=true&"
import script from "./getidentity.vue?vue&type=script&lang=js&"
export * from "./getidentity.vue?vue&type=script&lang=js&"
import style0 from "./getidentity.vue?vue&type=style&index=0&id=4ba4e813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba4e813",
  null
  
)

export default component.exports